import React,{useState} from 'react'
import cn from "classnames";
import { Divider } from "antd";

import styles from "./CreateMultipleTotes.module.sass"
import Modal from '../../../components/Modal';
import TextInput from '../../../components/TextInput';
import CustomAlert from '../../../components/CustomAlert';
import CustomToast from '../../../components/CustomToast';
import { CREATE_TOTES } from '../../../API/Totes';

const CreateMultipleTotes = ({ isModalVisible, handleModalClose, handleDeleteConfirm, handleSuccess,setNewCreatedTotes }) => {
    const [search, setSearch] = useState("");

    const { showAlert } = CustomAlert();
    const showToast = CustomToast();

    const onInputChange = (e) => {
        //only allow numbers
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setSearch(e.target.value)
        }
    }

    const handleOnCreateClick = async () => {
        const int_search = parseInt(search);
        try {
            if(search === ""){
                showAlert(
                    "Warning",
                    "Please enter the number of totes you want to create.",
                    "warning",
                    "Okay",
                    undefined, 
                    null, 
                    false, 
                    true, 
                    false
                  ).then(() => {
                    return;
                  });
            }
    
            if(int_search > 500){
                showAlert(
                    "Warning",
                    "You can only create a maximum of 500 totes at a time.",
                    "warning",
                    "Okay",
                    undefined, 
                    null, 
                    false, 
                    true, 
                    false
                  ).then(() => {
                    return;
                  });
            }
    
            const response = await CREATE_TOTES(int_search);
            setSearch("");
            handleModalClose();
            showToast(response.message, "success");
            setNewCreatedTotes(response.tote_codes);
            handleSuccess();
        } catch (error) {
            console.error("Failed to create totes:", error);
         if (error.response?.data?.errors) {
            const errorMessages = error.response.data.errors.map(err => 
                Object.values(err)[0]
            ).join(", ");
            showToast(errorMessages, "Error", 5);
        } else {
            const errorMessage = error.response?.data?.message || "Failed to create totes";
            showToast(errorMessage, "Error", 5);
        }
    }
    }

    return (
        <>
            <Modal outerClassName={styles.outer} visible={isModalVisible} onClose={handleModalClose}>
                <div className={styles.details}>
                    <div className={cn("title-green", styles.title)}>
                        Create New Tote
                    </div>
                    <div className={styles.roww}>
                        <div className={styles.coll}>
                            <p className="text-[#6F767E] pt-5 ">
                                Enter the total number of totes you want to create, and we’ll generate unique barcodes for each tote.
                            </p>
                            <p className="mt-[15px]">Enter Number</p>
                            <TextInput
                            className={"mt-2 p-0"}
                            type="text"
                            tooltip="Maximum 100 characters. No HTML or emoji allowed"
                            placeholder="How many totes do you want to add? ex- 04"
                            value={search}
                            onChange={(e) => onInputChange(e)}
                        />
                            <div className={cn(styles.btns)}>
                                <button
                                    type="button"
                                    className={cn("button-stroke pl-5 pr-5", styles.button)}
                                    onClick={handleModalClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={cn("button", styles.button)}
                                    onClick={handleOnCreateClick}
                                >
                                    Create Totes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CreateMultipleTotes